import { configureStore, combineReducers } from '@reduxjs/toolkit';
import logger from 'redux-logger';

// HISTORY
import { history } from 'config/history';

// REDUCER
import { connectRouter, routerMiddleware } from 'connected-react-router';
import appReducer, { initialState as appInitialState } from './app/slice';
import userReducer, { initialState as userInitialState } from './user/slice';
import contactReducer, { initialState as contactInitialState } from './contact/slice';
import addressReducer, { initialState as addressInitialState } from './address/slice';
import registerServiceReducer, {
  initialState as registerServeraddressInitialState
} from './service-registration/slice';
import onBoardingReducer, { initialState as onBoardingInitialState } from './onBoarding/slice';
import cartReducer, { initialState as cartInitialState } from './cart/slice';
import orderReducer, { initialState as orderInitialState } from './order/slice';
import serviceReducer, { initialState as serviceInitialState } from './service/slice';
import eventReducer, { initialState as eventInitialState } from './event/slice';
import sessionsReducer, { initialState as sessionInitialState } from './sessions/slice';
import centerReducer, { initialState as centerInitialState } from './center/slice';
import offerReducer, { initialState as offerInitialState } from './offer/slice';
import intakeReducer, { initialState as intakeInitialState } from './intake/slice';
import cardReducer, { initialState as cardInitialState } from './card/slice';
import denticareAppointmentReducer, {
  initialState as denticareAppointmentInitialState
} from './denticareBookAppointment/slice';
import productCatalogReducer, { initialState as productCatalogInitialState } from './productCatalog/slice';
import denticareClientReducer, { initialState as denticareClientInitialState } from './denticareClient/slice';
import medicalHistoryReducer, { initialState as medicalHistoryInitialState } from './medicalHistory/slice';
import appTourReducer, { initialState as appTourInitialState } from './appTour/slice';
import faqRecuder, { initialState as faqInitialState } from './faq/slice';
import egiroRecuder, { initialState as egiroInitialState } from './egiro/slice';
import feedbackReducer, { initialState as feedBackInitialState } from './feedback/slice';
import eInvoiceReducer, { initialState as eInvoiceInitialState } from './einvoice/slice';
import appointmentReducer, { initialState as appointmentState } from './appointmentConfirmation/slice';

// TYPE
import { RootState } from './type';
import checkInCheckOutReducer, { initialState as checkInCheckOutInitialState } from './checkInCheckOutCenter/slice';
import orgCheckInCheckOutReducer, {
  initialState as orgCheckInCheckOutInitialState
} from './checkInCheckOutOrgCenter/slice';
import aacCheckInCheckOutReducer, {
  initialState as aacCheckInCheckOutReducerInitialState
} from './checkInCheckOutAAC/slice';

export const reducer = combineReducers({
  appReducer,
  appTourReducer,
  userReducer,
  feedbackReducer,
  contactReducer,
  addressReducer,
  registerServiceReducer,
  cartReducer,
  orderReducer,
  serviceReducer,
  eventReducer,
  sessionsReducer,
  centerReducer,
  offerReducer,
  onBoardingReducer,
  intakeReducer,
  cardReducer,
  denticareAppointmentReducer,
  productCatalogReducer,
  denticareClientReducer,
  medicalHistoryReducer,
  faqRecuder,
  egiroRecuder,
  eInvoiceReducer,
  appointmentReducer,
  checkInCheckOutReducer,
  orgCheckInCheckOutReducer,
  aacCheckInCheckOutReducer,
  router: connectRouter(history)
});

export const initialAppState: Omit<RootState, 'router'> = {
  appReducer: appInitialState,
  appTourReducer: appTourInitialState,
  userReducer: userInitialState,
  contactReducer: contactInitialState,
  addressReducer: addressInitialState,
  registerServiceReducer: registerServeraddressInitialState,
  cartReducer: cartInitialState,
  cardReducer: cardInitialState,
  orderReducer: orderInitialState,
  serviceReducer: serviceInitialState,
  eventReducer: eventInitialState,
  sessionsReducer: sessionInitialState,
  centerReducer: centerInitialState,
  feedbackReducer: feedBackInitialState,
  offerReducer: offerInitialState,
  onBoardingReducer: onBoardingInitialState,
  intakeReducer: intakeInitialState,
  productCatalogReducer: productCatalogInitialState,
  denticareClientReducer: denticareClientInitialState,
  denticareAppointmentReducer: denticareAppointmentInitialState,
  medicalHistoryReducer: medicalHistoryInitialState,
  faqRecuder: faqInitialState,
  eInvoiceReducer: eInvoiceInitialState,
  egiroRecuder: egiroInitialState,
  appointmentReducer: appointmentState,
  checkInCheckOutReducer: checkInCheckOutInitialState,
  orgCheckInCheckOutReducer: orgCheckInCheckOutInitialState,
  aacCheckInCheckOutReducer: aacCheckInCheckOutReducerInitialState
};

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    process.env.REACT_APP_ENV === 'prod'
      ? getDefaultMiddleware().concat(routerMiddleware(history))
      : getDefaultMiddleware().concat(logger, routerMiddleware(history)),
  devTools: process.env.REACT_APP_ENV !== 'prod'
});
